<template>
  <div class="field" :class="{ 'field-compact': compact, 'has-error': error }">
    <label class="field-label">{{ label }}</label>
    <slot></slot>
    <div v-if="error" class="field-error">
      <LtIcon name="info" :size="13" />{{ error }}
    </div>
    <div v-else-if="hint" class="field-hint">{{ hint }}</div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';

export default {
  name: 'LtField',
  components: { LtIcon },
  props: {
    label:   { type: String, required: true },
    hint:    { type: String, default: '' },
    error:   { type: String, default: '' },
    compact: { type: Boolean, default: false },
  },
}
</script>
